import React from "react";
import { Navigate } from "react-router-dom";
import { Button, MessageBar, MessageBarActions, MessageBarBody } from "@fluentui/react-components";
import Loading from "../components/Loading";
import { useAuth } from "../auth/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, persistenceError, clearPersistenceError } = useAuth();

  if (loading) {
    return <Loading message="Checking authentication..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      {persistenceError ? (
        <MessageBar intent="warning" layout="singleline">
          <MessageBarBody>{persistenceError}</MessageBarBody>
          <MessageBarActions>
            <Button appearance="transparent" size="small" onClick={clearPersistenceError}>
              Dismiss
            </Button>
          </MessageBarActions>
        </MessageBar>
      ) : null}
      {children}
    </>
  );
};

export default ProtectedRoute;
